export default (function ($) {

    var _instance = {}

    /**
     * Initialize the method
     *
     * @return false
     */
    _instance.init = function () {
        $(document).ready(function () {

            var showDetailsButton = $('.cta--show-details');

            if (showDetailsButton.length > 0) {
                showDetailsButton.on('click', function (e) {
                    e.preventDefault();
                    if ($(this).hasClass('cta--active')) {
                        $(this).parent().find('.podcast__details').slideUp(500);
                        $(this).html('Show episode details').removeClass('cta--active');
                    } else {
                        $(this).parent().find('.podcast__details').slideDown(500);
                        $(this).html('Hide episode details').addClass('cta--active');
                    }
                })
            }


            var showDropdownButton = $('.js-open-dropdown');
            if (showDropdownButton.length > 0) {
                showDropdownButton.on('click', function (e) {
                    e.preventDefault();
                    $(this).parent().find(".menu--share").toggle();
                })
            }

        });
    };

    return _instance;

})(jQuery)